export default "__VITE_ASSET__c3f97884__"